import type { ReactNode } from 'react';

interface FormSectionProps {
  icon: string;
  title: string;
  description?: string;
  children: ReactNode;
}

export default function FormSection({ icon, title, description, children }: FormSectionProps) {
  return (
    <section className="lb-glass rounded-lg p-5">
      <div className="mb-4 flex items-start gap-3 border-b border-background-100 pb-4">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className={`${icon} text-lg leading-none`} aria-hidden="true" />
        </span>
        <div className="min-w-0">
          <h2 className="text-sm font-semibold text-foreground-950">{title}</h2>
          {description ? <p className="mt-0.5 text-xs text-foreground-500">{description}</p> : null}
        </div>
      </div>
      {children}
    </section>
  );
}